export default "__VITE_ASSET__9TOfV3a5__"